// extracted by mini-css-extract-plugin
module.exports = {"docs-page":"styles_docs-page__2kPGP","fill":"styles_fill__3rI8r"};